<template>
    <div class="mx-auto mt-6 max-w-xl">
        <section aria-labelledby="account_form_heading">
            <page
                :initial-account="account"
                :submit-text="$t('forms.button.preview')"
                class="shadow sm:rounded-md sm:overflow-hidden"
                @submit="preview"
            >
                <div>
                    <h2 id="account_form_heading" class="text-lg leading-6 font-medium text-gray-900">
                        {{ $t('build.title') }}
                    </h2>
                    <p class="mt-1 text-sm leading-5 text-gray-500">
                        {{ $t('build.subtitle') }}
                    </p>
                </div>
            </page>
        </section>
    </div>
</template>

<script>
    import Build from '@/layouts/Build.vue';
    import Page from '@/components/forms/Page.vue';

    export default {
        layout: Build,

        components: {
            Page,
        },

        props: {
            account: {
                type: Object,
                default: () => {},
            },
        },

        methods: {
            preview(currentForm) {
                const data = new FormData();
                Object.keys(currentForm).forEach((key) => {
                    if (currentForm[key] !== null) {
                        data.append(key, currentForm[key]);
                    }
                });

                const config = {
                    headers: { 'content-type': 'multipart/form-data' },
                };

                data.append('_method', 'put');

                this.$inertia.post(this.$route(), data, config);
            },
        },
    };
</script>
